import { RotateCcw } from 'lucide-react';

import type { Message as MessageType } from '@/modules/copilot/types';
import { Button } from '@/modules/ui/components/button/Button';
import {
  Conversation,
  ConversationContent,
  ConversationScrollButton,
} from '@/modules/ui/components/conversation/Conversation';
import {
  Message,
  MessageAvatar,
  MessageContent,
} from '@/modules/ui/components/message/Message';
import { Response } from '@/modules/ui/components/response/Response';
import { getInitials } from '@/utils/getInitials';

import { CopilotAvatar } from './CopilotAvatar';

interface CopilotConversationProps {
  userName: string;
  messages: MessageType[];
  onRetry: () => void;
}

export const CopilotConversation = ({
  userName,
  messages,
  onRetry,
}: CopilotConversationProps) => {
  return (
    <Conversation className="relative w-full">
      <ConversationContent>
        {messages.map((message, index) => {
          const isUser = message.role === 'user';
          const role = isUser ? 'user' : 'assistant';

          const isLoading = message.status === 'loading';
          const isError = message.status === 'error';
          const isLastMessage = index === messages.length - 1;
          const content = isLoading
            ? 'I&apos;m on it! Please give me a moment.'
            : message.content;

          return (
            <div key={message.id}>
              <Message from={role}>
                <MessageContent>
                  <Response>{content}</Response>
                </MessageContent>

                {isUser ? (
                  <MessageAvatar
                    name={getInitials(userName)}
                    src={''}
                    // TODO: add user avatar when backend is ready
                    className="h-8 w-8 text-white"
                  />
                ) : (
                  <CopilotAvatar isLoading={isLoading} />
                )}
              </Message>

              {isError && isLastMessage && (
                <div className="mt-2 flex justify-center">
                  <Button variant="outline" size="sm" onClick={onRetry}>
                    <RotateCcw />
                    Retry
                  </Button>
                </div>
              )}
            </div>
          );
        })}
      </ConversationContent>
      <ConversationScrollButton />
    </Conversation>
  );
};
